export enum SCOPE {
  SUPER_ADMIN = "SUPER_ADMIN",
  COMPANY_ADMIN = "COMPANY_ADMIN",
  USER = "USER",
}

export function scopeHas(scope: SCOPE | undefined, other: SCOPE): boolean {
  switch (scope) {
    case SCOPE.SUPER_ADMIN:
      return true
    case SCOPE.COMPANY_ADMIN:
      return other !== SCOPE.SUPER_ADMIN
    case SCOPE.USER:
      return other === SCOPE.USER
    case undefined:
      return false
  }
}
